import { createRouter, RouteRecordRaw, createWebHistory } from 'vue-router'
import { islogin, isNotLogin } from '@/middlewares/user_login';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/success',
    name: 'success',
    component: () => import('@/views/SuccessView.vue'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/ErrorView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    beforeEnter: islogin,
    component: () => import('@/views/LoginView.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/RegisterView.vue'),
  },
  {
    path: '/recharge/:idAccount',
    name: 'recharge',
    beforeEnter: isNotLogin,
    component: () => import('@/views/RechargeView.vue'),
    props: true,
  },
  {
    path: '/',
    name: 'home',
    beforeEnter: isNotLogin,
    component: () => import('@/views/HomeView.vue'),
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/students',
    name: 'students',
    beforeEnter: isNotLogin,
    component: () => import('@/views/StudentsView.vue'),
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/recharge-select',
    name: 'recharge-select',
    beforeEnter: isNotLogin,
    component: () => import('@/views/RechargeSelectView.vue'),
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/settings',
    name: 'settings',
    beforeEnter: isNotLogin,
    component: () => import('@/views/SettingsView.vue'),
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/newUser',
    name: 'newUser',
    beforeEnter: isNotLogin,
    component: () => import('@/views/NewUserView.vue'),
  },
  {
    path: '/tOf',
    name: 'tOf',
    component: () => import('@/views/ToFView.vue'),
  },
  {
    path: '/payACH',
    name: 'payACH',
    component: () => import('@/views/PayACH.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
  },
  {
    path: '/change_password',
    name: 'change-password',
    component: () => import('@/views/changePassword.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
})

export default router
